<template>
    <div>
        <compFormEdit
            class="margin-layout"
            ref="editform"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1"
        />
        <div class="text-right padding-bottom-20 padding-right-20">
            <Button type="primary" @click="submit">保存</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>
<script>
// import { HttpGetBillTotalList } from "@/service/newbigaccount";
import { HttpCreatedRehandle, HttpBillSummaryList } from "@/service/chargescalc";
import { mapGetters } from "vuex";
export default {
    data(){
        return {
            formData:{
                startTime:'',
                endTime:''
            },


        }
    },
    computed:{
        ...mapGetters('dictionary', ['getBillcusorgList']),
        getBase(){
            return [
                {
                    label: '账单编号',
                    key: 'billNo',
                    tag:'vInput',
                    span:24,
                    on:{
                        'on-blur':(val)=>{
                            this.getBillNoOne(val)
                        }
                    }
                },
                {
                    label: '仓库',
                    span:24,
                    key:'warehouseCode',
                    query:true
                },
                {
                    label: '结算账期',
                    span:24,
                    valueText:this.formData ? this.formData.startTime ? this.formData.endTime ? this.formData.startTime + '-' + this.formData.endTime : this.formData.startTime + '--' : '--' : '--',
                    query:true
                },
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    span:24,
                    key: 'expenseCategoryType',
                    options: [{ value: 0, label: '作业费' },
                        { value: 1, label: '仓储费' },
                        { value: 3, label: '增值服务费' },],
                    props:{
                        filterable:true,
                    },
                },
            ]
        },
    },
    methods:{
        getBillNoOne(val){
            if(!val)return;
            HttpBillSummaryList({
                'search[EQ_billNo]':val
            }).then(res=>{
                if(res.data.content[0]){
                    this.formData = res.data.content[0]
                }else{
                    this.$VMessage.error({content: '账单不存在'});
                    this.formData.startTime=''
                    this.formData.organizationName=''
                }
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        submit(){
            HttpCreatedRehandle({
                billId:this.formData.id,
                expenseCategoryType:this.formData.expenseCategoryType
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.$emit('on-update');
                this.cancel()
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>
